(function(){'use strict';
function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}
function findPinnedTopOffset(head){
  var vw=window.innerWidth||document.documentElement.clientWidth||0;
  if(!vw)return 0;
  var best=0;
  var hintRe=/(极速翻译|网页翻译|当前网页翻译|将当前网页翻译为|自动翻译|translate|translator|translation|fanyi)/i;
  function isThemeNode(node){
    if(!node||node===document.documentElement||node===document.body)return false;
    if(node===head||head.contains(node)||node.contains(head))return true;
    if(node.closest&&node.closest('[id^="shopify-section-site-header"]'))return true;
    return false;
  }
  function isShopifySectionNode(node){
    return !!(node&&node.closest&&node.closest('[id^="shopify-section-"]'));
  }
  function getHintText(node){
    var bits=[];
    try{
      bits.push(node.id||'');
      bits.push(typeof node.className==='string'?node.className:'');
      bits.push(node.getAttribute&&node.getAttribute('title')||'');
      bits.push(node.getAttribute&&node.getAttribute('aria-label')||'');
      bits.push(node.getAttribute&&node.getAttribute('src')||'');
      var tx=node.innerText||node.textContent||'';
      if(tx&&tx.length<600)bits.push(tx);
    }catch(e){}
    return bits.join(' ');
  }
  function inspect(el){
    if(!el||el===document.documentElement||el===document.body||isThemeNode(el))return;
    var node=el;
    var depth=0;
    while(node&&node!==document.body&&node!==document.documentElement&&depth<10){
      if(isThemeNode(node))break;
      var cs=window.getComputedStyle(node);
      var r=node.getBoundingClientRect();
      var z=parseInt(cs.zIndex,10);
      var src=(node.getAttribute&&node.getAttribute('src'))||node.src||'';
      var isExtensionFrame=node.tagName==='IFRAME'&&/^(chrome-extension|moz-extension|edge-extension):/i.test(src);
      var hinted=hintRe.test(getHintText(node));
      var nearTop=r.top<=4&&r.bottom>20;
      var toolbarSize=r.height>=24&&r.height<=160&&r.width>=vw*.58;
      var pinned=cs.position==='fixed'||cs.position==='sticky';
      var directForeign=(node.parentElement===document.body||node.parentElement===document.documentElement)&&!isShopifySectionNode(node);
      var likelyToolbar=nearTop&&toolbarSize&&(isExtensionFrame||hinted||(pinned&&!Number.isNaN(z)&&z>=40)||directForeign);
      if(likelyToolbar){
        best=Math.max(best,Math.min(160,Math.ceil(r.bottom)));
      }
      node=node.parentElement;
      depth++;
    }
  }
  [vw*.08,vw*.25,vw*.5,vw*.75,vw*.92].forEach(function(x){
    if(document.elementsFromPoint){document.elementsFromPoint(x,2).forEach(inspect);}
  });
  document.querySelectorAll('iframe').forEach(function(frame){
    var src=(frame.getAttribute('src')||frame.src||'');
    if(/^(chrome-extension|moz-extension|edge-extension):/i.test(src))inspect(frame);
  });
  Array.prototype.forEach.call(document.body?document.body.children:[],inspect);
  function positivePx(v){
    var n=parseFloat(v);
    return Number.isFinite(n)&&n>0&&n<=160?n:0;
  }
  function transformY(cs){
    var t=cs&&cs.transform;
    if(!t||t==='none')return 0;
    var m=t.match(/^matrix\(([^)]+)\)$/);
    if(m){
      var p=m[1].split(',');
      return positivePx(p[5]);
    }
    var m3=t.match(/^matrix3d\(([^)]+)\)$/);
    if(m3){
      var p3=m3[1].split(',');
      return positivePx(p3[13]);
    }
    return 0;
  }
  function pageShift(){
    var shift=0;
    [document.documentElement,document.body].forEach(function(el){
      if(!el)return;
      var cs=window.getComputedStyle(el);
      shift=Math.max(
        shift,
        positivePx(el.style&&el.style.top),
        positivePx(cs.top),
        positivePx(el.style&&el.style.marginTop),
        positivePx(cs.marginTop),
        positivePx(el.style&&el.style.paddingTop),
        transformY(cs)
      );
      if((window.scrollY||window.pageYOffset||0)<=2){
        var r=el.getBoundingClientRect();
        if(r.top>0&&r.top<=160)shift=Math.max(shift,r.top);
      }
    });
    return shift;
  }
  try{
    document.querySelectorAll('[id*="translate"],[class*="translate"],[id*="translator"],[class*="translator"],[id*="fanyi"],[class*="fanyi"],iframe').forEach(inspect);
    Array.prototype.forEach.call(document.documentElement.children||[],inspect);
  }catch(e){}
  best=Math.max(best,pageShift());
  return best?Math.min(164,Math.ceil(best+4)):0;
}
function setupHeaderOffset(head){
  var root=document.documentElement;
  var last=-1;
  var queued=false;
  function sync(){
    queued=false;
    var next=findPinnedTopOffset(head);
    if(next!==last){last=next;root.style.setProperty('--senlo-external-top-offset',next+'px');}
  }
  function requestSync(){if(!queued){queued=true;requestAnimationFrame(sync);}}
  sync();
  window.addEventListener('resize',requestSync,{passive:true});
  window.addEventListener('scroll',requestSync,{passive:true});
  if(window.visualViewport){window.visualViewport.addEventListener('resize',requestSync,{passive:true});window.visualViewport.addEventListener('scroll',requestSync,{passive:true});}
  var resizeObserver=null;
  function observeTopLevel(){
    if(!resizeObserver||!document.body)return;
    Array.prototype.forEach.call(document.body.children,function(el){
      if(el!==head&&!head.contains(el)&&!el.contains(head)){try{resizeObserver.observe(el);}catch(e){}}
    });
  }
  if(window.ResizeObserver){resizeObserver=new ResizeObserver(requestSync);observeTopLevel();}
  var observer=new MutationObserver(function(){observeTopLevel();requestSync();});
  observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class','src']});
  [100,250,500,900,1500,3000,6000,10000].forEach(function(ms){setTimeout(requestSync,ms);});
}
ready(function(){
  var head=document.querySelector('.md28410.md-head');if(!head)return;
  setupHeaderOffset(head);
  var more=head.querySelector('.h-more'),off=head.querySelector('.md-mob_sideNav .m_off'),mask=head.querySelector('.mob_mask');
  if(more)more.addEventListener('click',function(){head.classList.toggle('m_show');});
  if(off)off.addEventListener('click',function(){head.classList.remove('m_show');});
  if(mask)mask.addEventListener('click',function(){head.classList.remove('m_show');});
  head.querySelectorAll('.md-mob_sideNav .ul1 .arrow').forEach(function(a){a.addEventListener('click',function(){var dt=a.parentElement;var ul=dt.parentElement.querySelector('ul');var op=dt.classList.contains('show');dt.classList.toggle('show',!op);if(ul)ul.style.display=op?'none':'block';});});
  head.querySelectorAll('.md-mob_sideNav .ul1 .dt').forEach(function(dt){if(!dt.parentElement.querySelector('ul')){var a=dt.querySelector('.arrow');if(a)a.style.display='none';}});
  var sb=document.querySelector('.md28410.md-head .h-search'),sf=document.querySelector('.md28410.md-search_form');
  if(sb&&sf){sb.addEventListener('click',function(){sf.classList.add('show');});var m2=sf.querySelector('.mask');if(m2)m2.addEventListener('click',function(){sf.classList.remove('show');});}
  var els=document.querySelectorAll('[data-ani]');if(els.length){var tick=false;function chk(){tick=false;var h=window.innerHeight||document.documentElement.clientHeight;els.forEach(function(el){var r=el.getBoundingClientRect();if(r.top<h*.9&&r.bottom>0)el.classList.add('ani');});}chk();window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(chk);}},{passive:true});}
});
})();


/* SENLO HERO V2 */
(function(){
  function initHero(root){
    var scope=root||document;
    var heroes=scope.querySelectorAll ? scope.querySelectorAll('[data-senlo-hero]') : [];
    heroes.forEach(function(hero){
      if(hero.dataset.mode==='video'){
        var video=hero.querySelector('.senlo-hero-v2__video');
        if(!video) return;
        if(video.dataset.senloEndBound==='1') return;
        video.dataset.senloEndBound='1';
        var freeze=hero.dataset.freezeLastFrame==='true';
        var loopEnabled=hero.dataset.videoLoop==='true';
        var media=video.closest('.senlo-hero-v2__media');
        function markVideoFrameReady(){
          if(media) media.classList.add('has-video-frame');
        }
        if(video.readyState>=2){
          markVideoFrameReady();
        }else{
          video.addEventListener('loadeddata',markVideoFrameReady,{once:true});
          video.addEventListener('canplay',markVideoFrameReady,{once:true});
          video.addEventListener('playing',markVideoFrameReady,{once:true});
        }
        if(!loopEnabled){
          video.addEventListener('ended',function(){
            try{
              video.pause();
              if(freeze){
                var duration=Number(video.duration);
                if(Number.isFinite(duration)&&duration>0){
                  video.currentTime=Math.max(0,duration-0.04);
                }
              }else{
                video.currentTime=0;
              }
            }catch(e){}
          });
        }
        return;
      }
      if(hero.dataset.mode!=='images') return;
      if(hero.dataset.carousel!=='true') return;
      var container=hero.querySelector('.senlo-hero-v2__swiper');
      if(!container || container.classList.contains('swiper-initialized') || container.querySelectorAll('.swiper-slide').length<2) return;
      if(typeof window.Swiper!=='function') return;
      var delay=parseInt(hero.dataset.delay||'7000',10);
      var speed=parseInt(hero.dataset.speed||'900',10);
      var pagination=hero.dataset.pagination==='true' ? {
        el:hero.querySelector('.senlo-hero-v2__pagination'),
        clickable:true
      } : undefined;
      new window.Swiper(container,{
        observer:true,
        observeParents:true,
        loop:true,
        slidesPerView:1,
        speed:speed,
        autoplay:{delay:delay,disableOnInteraction:false,pauseOnMouseEnter:true},
        pagination:pagination
      });
    });
  }
  function boot(){initHero(document);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',function(e){initHero(e.target);});
})();


/* SENLO HERO END REVEAL */
(function(){
  function initSenloHeroEndReveal(scope){
    var root=scope||document;
    var heroes=root.querySelectorAll ? root.querySelectorAll('[data-senlo-hero][data-mode="video"]') : [];

    heroes.forEach(function(hero){
      var video=hero.querySelector('.senlo-hero-v2__video');
      var overlay=hero.querySelector('.senlo-hero-v2__video-overlay');
      var copy=hero.querySelector('.senlo-hero-v2__copy--video');
      if(!video||!overlay||!copy) return;
      if(hero.dataset.endRevealBound==='1') return;
      hero.dataset.endRevealBound='1';

      var revealSeconds=Math.max(.5,parseFloat(hero.dataset.revealSeconds||'6'));
      var maxOpacity=Math.max(0,Math.min(.95,parseFloat(hero.dataset.overlayOpacity||'.55')));
      var loopEnabled=hero.dataset.videoLoop==='true';
      var locked=false;
      var revealStarted=false;
      var lastTime=0;

      function resetInitial(){
        if(locked) return;
        overlay.style.opacity='0';
        copy.style.opacity='0';
        copy.style.transform='translateY(18px)';
        copy.classList.remove('is-revealing','is-final');
      }

      function finalState(){
        locked=true;
        revealStarted=true;
        overlay.style.opacity=String(maxOpacity);
        copy.style.opacity='1';
        copy.style.transform='translateY(0)';
        copy.classList.add('is-revealing','is-final');
      }

      function update(){
        if(locked){
          finalState();
          return;
        }

        var duration=Number(video.duration);
        if(!Number.isFinite(duration)||duration<=0) return;

        var t=Number(video.currentTime)||0;
        var startTime=Math.max(0,duration-revealSeconds);

        // A loop can jump from the end straight back to 0 before an "ended" event fires.
        // Once the reveal has begun, that jump locks the final visual state permanently.
        if(loopEnabled && revealStarted && t+0.5<lastTime){
          finalState();
          lastTime=t;
          return;
        }
        lastTime=t;

        if(t<startTime){
          resetInitial();
          return;
        }

        revealStarted=true;

        // Start at the requested "last N seconds", but finish the fade in ~2 seconds.
        // Then keep the darkened frame + copy visible for the rest of the first loop
        // and all subsequent loops.
        var fadeDuration=Math.max(.6,Math.min(2,revealSeconds));
        var progress=(t-startTime)/fadeDuration;
        progress=Math.max(0,Math.min(1,progress));

        overlay.style.opacity=String(maxOpacity*progress);
        copy.style.opacity=String(progress);
        copy.style.transform='translateY('+((1-progress)*18)+'px)';
        copy.classList.add('is-revealing');

        if(progress>=.995){
          finalState();
        }
      }

      video.addEventListener('loadedmetadata',update);
      video.addEventListener('timeupdate',update);
      video.addEventListener('seeking',update);
      video.addEventListener('ended',function(){
        if(!loopEnabled) finalState();
      });

      resetInitial();
      update();
    });

    var forms=root.querySelectorAll ? root.querySelectorAll('[data-senlo-hero-add]') : [];
    forms.forEach(function(form){
      if(form.dataset.heroAddBound==='1') return;
      form.dataset.heroAddBound='1';
      form.addEventListener('submit',async function(e){
        e.preventDefault();
        var button=form.querySelector('button[type="submit"]');
        if(button&&button.disabled) return;
        var original=button ? button.textContent : '';
        try{
          if(button){button.disabled=true;button.textContent='Adding…';}
          var res=await fetch(form.action+'.js',{
            method:'POST',
            headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:new FormData(form)
          });
          var data=await res.json();
          if(!res.ok) throw new Error(data.description||data.message||'Unable to add item');
          document.dispatchEvent(new CustomEvent('senlo:cart:updated',{detail:{open:true}}));
        }catch(err){
          window.alert(err.message||'Unable to add item');
        }finally{
          if(button){button.disabled=false;button.textContent=original;}
        }
      });
    });
  }

  function boot(){initSenloHeroEndReveal(document);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',function(e){initSenloHeroEndReveal(e.target);});
})();


/* SENLO HERO SCROLL COVER */
(function(){
  function initSenloHeroScrollCover(scope){
    var root=scope||document;
    var heroes=root.querySelectorAll ? root.querySelectorAll('[data-senlo-hero][data-scroll-cover="true"]') : [];

    heroes.forEach(function(hero){
      if(hero.dataset.scrollCoverBound==='1') return;

      var heroSection=hero.closest('[id^="shopify-section-"]');
      if(!heroSection) return;

      var secondSection=heroSection.nextElementSibling;
      while(secondSection && !secondSection.querySelector('.md-home-1.md28515')){
        // Only search a very short distance so another inserted app/empty node
        // between homepage screen 1 and 2 doesn't break the effect.
        if(secondSection.matches && secondSection.matches('[id^="shopify-section-"]')) break;
        secondSection=secondSection.nextElementSibling;
      }
      if(!secondSection || !secondSection.querySelector('.md-home-1.md28515')) return;

      hero.dataset.scrollCoverBound='1';
      heroSection.classList.add('senlo-cover-hero-wrapper');
      secondSection.classList.add('senlo-cover-second-wrapper');

      var queued=false;

      function getStickyTop(){
        var external=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--senlo-external-top-offset'))||0;
        var header=document.getElementById('shopify-section-site-header');
        var headerHeight=header ? header.getBoundingClientRect().height : 0;
        return Math.max(0,Math.round(external+headerHeight));
      }

      function sync(){
        queued=false;
        var stickyTop=getStickyTop();
        heroSection.style.setProperty('--senlo-cover-top',stickyTop+'px');

        var secondRect=secondSection.getBoundingClientRect();

        // Progressive cover behavior:
        // while screen 2 is moving upward, screen 1 stays visible and its video keeps playing.
        // Only after the top edge of screen 2 reaches the sticky top (under the header)
        // is screen 1 fully covered and therefore safe to hide.
        var fullyCovered = secondRect.top <= stickyTop + 1;

        if(fullyCovered){
          heroSection.classList.add('senlo-cover-content-hidden');
          heroSection.classList.add('senlo-cover-complete');
        }else{
          heroSection.classList.remove('senlo-cover-content-hidden');
          heroSection.classList.remove('senlo-cover-complete');
        }
      }

      function requestSync(){
        if(queued) return;
        queued=true;
        requestAnimationFrame(sync);
      }

      sync();
      window.addEventListener('scroll',requestSync,{passive:true});
      window.addEventListener('resize',requestSync,{passive:true});
      if(window.visualViewport){
        window.visualViewport.addEventListener('resize',requestSync,{passive:true});
      }
    });
  }

  function boot(){initSenloHeroScrollCover(document);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();

  document.addEventListener('shopify:section:load',function(e){
    initSenloHeroScrollCover(document);
  });
})();
